module.exports = __webpack_public_path__ + "img/1485130104.399fe65e.jpg";